import { Injectable } from '@angular/core';
import { FiltersTypeEnum } from 'world-archery-lib';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { RegionCombo, IRegionComboData, CountryCombo, TextFilter } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import MemberAssociationsStore from 'src/app/common-page-components/stores/entities-store/continental-associations-store';

/**
 * Provides filter for member association pages.
 *
 * @export
 * @class MembersSearchFiltersService
 * @extends {FiltersAbstractService}
 */
@Injectable({
  providedIn: 'root'
})
export class MembersSearchFiltersService extends FiltersAbstractService {
  sharedSubjectForCombo = new BehaviorSubject({Continent:'All'});
  // tslint:disable-next-line:max-line-length
  regionCombo = new RegionCombo('Region:', 'regionmembercombo', this.http, this.sharedSubjectForCombo, [{ item: { Continent: 'All' }, position: 0 }]);
  textFilter = new TextFilter('membersearchinput');
  filtersType: any = [
    this.textFilter.filterInfo,
    this.regionCombo.filterInfo
  ];

  /**
   * Creates an instance of MembersSearchFiltersService.
   *
   * @param {HttpClient} http
   * @memberof MembersSearchFiltersService
   */
  constructor(private http: HttpClient) {
    super();
  }

  /**
   * {@inheritdoc}
   *
   * @memberof MembersSearchFiltersService
   */
  generateDefaultValues(): void {}

  /**
   * {@inheritdoc}
   *
   * @returns {[IRegionComboData]}
   * @memberof MembersSearchFiltersService
   */
  getDataStreamWithFilters() {
    return combineLatest([this.orderValue, this.textFilter.data(), this.regionCombo.comboData]);
  }

}
